import { Grid } from "antd";
import { ComponentType, FC } from "react";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

export function withConditionalComponent<D extends object, M extends object>(
  ComponentA: ComponentType<D>,
  ComponentB: ComponentType<M>
) {
  const ConditionalComponent: FC<{
    trigger?: boolean;
    props?:D | M;
    componentAProps?: D;
    componentBProps?: M;
  }> = ({ trigger, componentAProps, componentBProps, props }) => {
    const triggerFallback = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
    return trigger ? (
      <ComponentA {...props} {...(componentAProps || ({} as D))} />
    ) : (
      <ComponentB  {...props} {...(componentBProps || ({} as M))} />
    );
  };

  return ConditionalComponent;
}